import { IdentityPayload } from '../../util/identity/lib/identity.interfaces';
import { ApiResource } from '../api-resource';
import { Customer } from '../customer/customer.model';
import {
  createMedicalInformationFormGroup,
  MedicalInformation,
} from '../_lib/medical-info';
import {
  createEmergencyContactFormGroup,
  EmergencyContact,
} from '../_lib/emergency';
import {
  BooleanField,
  DateField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields/resource-fields';
import { DiscountSubscription } from '../discount/lib/discount.interfaces.js';
import { Endpoint } from '../api.decorators';
import { Address } from '../_lib/address';
import { Name } from '../_lib/name';

@Endpoint('children', 'Child')
export class Child extends ApiResource<Child> implements Name, Address {
  @StringField({ label: $localize`First name` })
  firstName!: string;

  @StringField({ label: $localize`Last name` })
  lastName!: string;
  customer: any;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  @Field({
    readonly: true,
    label: $localize`Avatar`,
    includeFilter: false,
    type: () => Blob,
  })
  avatar!: string;

  @DateField({ label: $localize`Date of birth` })
  dateOfBirth!: Date;

  @Field({ label: $localize`Address` })
  address!: string;

  @StringField({ label: $localize`Extra information` })
  extraInformation!: string;

  @StringField({ label: $localize`City` })
  city!: string;

  @StringField({ label: $localize`Postal code` })
  zipCode!: string;

  @StringField({ label: $localize`Country` })
  country!: string;

  @Field({ includeFilter: false })
  identities!: IdentityPayload[];

  @Field({
    formControlFactory: createMedicalInformationFormGroup,
    includeFilter: false,
    label: $localize`Medical information`,
  })
  medicalInformation!: MedicalInformation;

  @Field({
    formControlFactory: createEmergencyContactFormGroup,
    includeFilter: false,
  })
  emergencyInformation!: EmergencyContact[];

  @BooleanField({
    default: () => false,
    label: $localize`May appear in photos`,
  })
  mayAppearInPhotos!: boolean;

  @BooleanField({ default: () => false, label: $localize`May go home alone` })
  mayGoHomeAlone!: boolean;

  @Field({ type: () => Customer, label: $localize`Parents` })
  parents!: Customer[];

  discountSubscriptions?: DiscountSubscription[];

  override toLabel(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
